// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"VIP_ListItem__checkboxLabel"};